import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.admin.info');
import { OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import html2canvas from 'html2canvas';

@Component({
    selector: 'wiz-portal-institute-admin-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.admin.info/view.scss */
/* src/app/portal.institute.admin.info/view.scss: no such file or directory */`],
})
export class PortalInstituteAdminInfoComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    @ViewChild('chartBox', { static: false }) chartBox!: ElementRef<HTMLElement>;

    @Input() insID: any;
    @Input() mode: any;

    public insTypes: any = ["공공기관", "교육기관", "산업체", "정부출연기관", "학협회"];
    public locations: any = ["강원", "경기", "경남", "경북", "광주", "대구", "대전", "부산", "서울", "세종", "울산", "인천", "전남", "전북", "제주", "춘천", "충남", "충북", "평창"];

    public trafficPeriod: 7 | 14 | 30 | 180 = 7;
    public traffic: any = null;
    public selectedNetwork: any = { tr: 30 };

    public institute: any = {};
    public networks: any = [];
    public selectedPortID: any;
    public port: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관정보 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { insID: this.insID });
        if (code != 200) return await this.service.alert.error("Error!");
        this.institute = data.institute;
        this.networks = data.networks;
        this.setSeletedPort(this.networks[0].id);
        await this.service.render();
    }

    public async saveInstitute(ins: any) {
        const { code, data } = await wiz.call("saveInstitute", ins);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("기관 정보가 수정되었습니다.");
    }

    public async saveNetwork(port: any) {
        let networkInfo = cloneDeep(port);
        delete networkInfo.extra;
        delete networkInfo.person;
        delete networkInfo.updated;

        const { code, data } = await wiz.call("saveNetwork", networkInfo);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("회선 정보가 수정되었습니다.");
    }

    public async setSeletedPort(id: any) {
        this.selectedPortID = id;
        this.port = this.networks.find(item => item.id === this.selectedPortID);
        if (this.port?.annual_fee != null && this.port.annual_fee !== '') {
            this.port.annual_fee = Number(this.port.annual_fee).toLocaleString('ko-KR');
        }
        if (this.port?.year_annual_fee != null && this.port.year_annual_fee !== '') {
            this.port.year_annual_fee = Number(this.port.year_annual_fee).toLocaleString('ko-KR');
        }
        await this.selectNetwork(this.port);
        await this.service.render();
    }

    public async selectNetwork(item: any) {
        let tr = this.trafficPeriod;
        this.traffic = null;
        await this.service.render();

        const { code, data } = await wiz.call("loadNetwork", { ...item, tr: tr });
        if (code != 200) return await this.service.alert.error("Error!");

        if (data) {
            for (let i = 0; i < data._time.length; i++)
                data._time[i] = (moment(data._time[i]).add(9, 'hours')).format("YYYY-MM-DD HH:mm:ss");

            this.traffic = {
                category: data._time,
                series: [{
                    name: 'IN',
                    data: data._in
                }, {
                    name: 'OUT',
                    data: data._out
                }]
            };
        }

        this.selectedNetwork = item;
        this.selectedNetwork.tr = tr;
        await this.service.render();
    }

    private periodText(): string {
        const m = { 7: '1주', 14: '2주', 30: '1개월', 180: '6개월' } as any;
        return m[this.trafficPeriod] ?? `${this.trafficPeriod}일`;
    }

    private buildTitle(): string {
        const inst = this.institute?.name ?? '';
        const net = this.selectedNetwork?.name ?? '';
        const per = this.periodText();
        return `[${inst}]의 <${net}> 회선의 ${per} 내 네트워크 트래픽 사용량`;
    }

    public async downloadChartImage() {
        if (!this.chartBox) return;

        // 렌더 안정화가 필요하면 약간 대기
        await new Promise(r => setTimeout(r, 50));

        const node = this.chartBox.nativeElement;

        const chartCanvas = await html2canvas(node, {
            scale: Math.max(2, window.devicePixelRatio || 1), // 고해상도
            useCORS: true,             // 외부 폰트/이미지 있을 때
            backgroundColor: '#ffffff' // 투명 배경 방지
        });

        // 타이틀 합성 캔버스 만들기
        const title = this.buildTitle();

        const paddingX = 24;       // 좌우 여백(px)
        const paddingTop = 18;     // 타이틀 상단 여백
        const paddingBottom = 12;  // 타이틀 하단 여백
        const titleFontPx = 32;    // 타이틀 폰트 크기
        const titleHeight = paddingTop + titleFontPx + paddingBottom;

        const totalW = chartCanvas.width;
        const totalH = titleHeight + chartCanvas.height;

        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = totalW;
        finalCanvas.height = totalH;

        const ctx = finalCanvas.getContext('2d')!;
        // 배경 흰색
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, totalW, totalH);

        // 타이틀 텍스트
        ctx.font = `600 ${titleFontPx}px system-ui, -apple-system, Segoe UI, Roboto, Sans-Serif`;
        ctx.fillStyle = '#111827'; // gray-900
        ctx.textBaseline = 'top';

        // 한 줄로 길 경우 잘리므로, 간단한 줄바꿈 처리
        const maxTextWidth = totalW - paddingX * 2;
        const lines: string[] = [];
        const words = title.split(' ');
        let line = '';
        for (const w of words) {
            const test = line ? line + ' ' + w : w;
            if (ctx.measureText(test).width <= maxTextWidth) line = test;
            else { lines.push(line); line = w; }
        }
        if (line) lines.push(line);
        // 줄들을 그리기
        let y = paddingTop;
        for (const l of lines) {
            ctx.fillText(l, paddingX, y);
            y += titleFontPx + 4; // 줄 간격
        }
        const usedTitleHeight = Math.max(titleHeight, y + paddingBottom - 4);

        // 차트 캔버스 붙이기
        ctx.drawImage(chartCanvas, 0, usedTitleHeight);

        // const dataUrl = canvas.toDataURL('image/png');
        const dataUrl = finalCanvas.toDataURL('image/png');

        // 다운로드 링크 생성
        const a = document.createElement('a');
        const name = (this.selectedNetwork?.name || 'traffic') + `_p${this.trafficPeriod}d`;
        a.href = dataUrl;
        a.download = `${name}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    public formatAmount(event: any) {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/,/g, ''); // 기존 쉼표 제거
        value = value.replace(/\D/g, ''); // 숫자만 남기기

        if (value === '') {
            // 🔹 다 지웠을 때는 빈 값 유지
            input.value = null;
            return;
        }

        // 🔹 숫자일 경우에만 3자리 쉼표 추가
        const formatted = Number(value).toLocaleString('ko-KR');
        input.value = formatted;
    }

    // 장비 설정 관련 이벤트
    public selectPortItem: any = null;
    public async selectPort() {
        this.selectPortItem = cloneDeep(this.port);
        // this.selectPortItem = this.port;
        if (!this.selectPortItem.extra2.devices) this.selectPortItem.extra2.devices = [];
        await this.service.render();
    }

    public async selectedPort(info: any) {
        this.selectPortItem.extra2.devices = info;
        let item = JSON.parse(JSON.stringify(this.selectPortItem));
        const { code, data } = await wiz.call("updatePort", { id: item.id, extra: JSON.stringify(item.extra2) });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("저장되었습니다.");
        await this.selectedNetwork(this.selectPortItem);
        this.selectPortItem = null;
        await this.service.render();
    }

    public async removePort() {
        this.selectPortItem = null;
        await this.service.render();
    }
}

export default PortalInstituteAdminInfoComponent;